import axios, { AxiosError } from 'axios';

export async function checkInternet(
    pingUrl = 'https://frontend-api.upmyshop.com/api/v1/check',
    timeout = 2000
) {
    try {
        const response = await axios({
            method: 'HEAD',
            url: pingUrl,
            timeout: timeout,
            // Désactive la validation du certificat si nécessaire
            // validateStatus: () => true
        });
        const newStatus = response.status === 200;
        console.log(`[${new Date().toISOString()}] État de la connexion (try):`, newStatus);
        return newStatus;
    } catch (error) {
        const newStatus = false;
        console.log(
            `[${new Date().toISOString()}] État de la connexion (catch):`,
            newStatus,
            axios.isAxiosError(error) && error.code === 'ECONNABORTED' ? '(timeout)' : ''
        );
        return newStatus;
    }
}